'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _InlineOverlayFooter = require('./components/InlineOverlayFooter.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InlineOverlayFooter).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-inline-overlay/lib/components/inline-overlay-footer/index.js
// module id = 1321
// module chunks = 1